import { Box, Stack } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CreditKindRadioCard } from './CreditKindRadio/CreditKindRadioCard.tsx';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import OfflineBoltOutlinedIcon from '@mui/icons-material/OfflineBoltOutlined';
import { AddCreditForm } from '../add-credit-form/add-credit-form-schema.ts';
import { CREDIT_KINDS } from '@vy/types';

export const CreditKindRadioCards: React.FC = () => {
  const { watch, setValue } = useFormContext<AddCreditForm>();
  const creditKind = watch('creditKind');

  return (
    <Stack direction="row" spacing={2}>
      <Box data-vy="add-credit-drawer-credit-kind-amount-card" sx={{ flex: 1, display: 'flex' }}>
        <CreditKindRadioCard
          title="Amount ($)"
          icon={<MonetizationOnOutlinedIcon />}
          isSelected={creditKind === CREDIT_KINDS.MONETARY}
          onClick={() =>
            setValue('creditKind', CREDIT_KINDS.MONETARY, { shouldDirty: true, shouldValidate: true })
          }
        />
      </Box>
      <Box data-vy="add-credit-drawer-credit-kind-units-card" sx={{ flex: 1, display: 'flex' }}>
        <CreditKindRadioCard
          title="Units"
          icon={<OfflineBoltOutlinedIcon />}
          isSelected={creditKind === CREDIT_KINDS.UNIT}
          onClick={() =>
            setValue('creditKind', CREDIT_KINDS.UNIT, { shouldDirty: true, shouldValidate: true })
          }
          disabled
        />
      </Box>
    </Stack>
  );
};
